import { render, staticRenderFns } from "./TextImageFullWidth.vue?vue&type=template&id=f7d58a4e&"
import script from "./TextImageFullWidth.vue?vue&type=script&lang=js&"
export * from "./TextImageFullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports